import React from 'react';
import { Bug, Lightbulb, Mail, MessageSquare, ShieldQuestion } from 'lucide-react';
import './ContactPage.css';

const SUPPORT_EMAIL = 'support@maicolleges.com';
const BUG_FEATURE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSeeM81wlBlaGlwaO5zZCo-3X0wP0wKe5kMuGodEffWcIXSx1w/viewform?usp=publish-editor';

const contactReasons = [
  {
    icon: Bug,
    title: 'Report a bug',
    text: 'Share what page you were on, what you clicked, and what happened.',
  },
  {
    icon: ShieldQuestion,
    title: 'Account help',
    text: 'Ask about login issues, saved work, or anything that feels off in your account.',
  },
  {
    icon: Lightbulb,
    title: 'Suggest an idea',
    text: 'Send feedback for dashboards, progress tracking, reminders, or calendar planning.',
  },
];

function ContactPage() {
  return (
    <main className="contact-page">
      <div className="contact-page__inner">
        <header className="contact-page__header">
          <span className="contact-page__eyebrow">Contact</span>
          <h1>Contact Us</h1>
          <p>Reach out for help, bug reports, feedback, or questions about your college planning workflow.</p>
        </header>

        <section className="contact-page__layout">
          <div className="contact-page__panel">
            <div className="contact-page__panel-header">
              <MessageSquare size={19} strokeWidth={1.7} />
              <h2>What to include</h2>
            </div>
            <ul>
              <li>The page you were using, like Dashboard, Progress, Calendar, or Account.</li>
              <li>What you expected to happen.</li>
              <li>What actually happened.</li>
              <li>Any college, task, deadline, or dashboard name involved.</li>
            </ul>
          </div>

          <aside className="contact-page__email-card">
            <div className="contact-page__email-icon">
              <Mail size={21} strokeWidth={1.7} />
            </div>
            <h2>Email support</h2>
            <p>Send questions, bug reports, account help requests, or feedback to the MaiColleges support inbox.</p>
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </aside>
        </section>

        <section id="bug-feature-form" className="contact-page__form-cta" aria-label="Bug and feature form">
          <div>
            <span className="contact-page__eyebrow">Feedback form</span>
            <h2>Report a bug or request a feature</h2>
            <p>Use the form for dashboard issues, confusing steps, missing features, or anything that would make MaiColleges easier to use.</p>
          </div>
          <a href={BUG_FEATURE_FORM_URL} target="_blank" rel="noreferrer">Open Form</a>
        </section>

        <section className="contact-page__reasons" aria-label="Bug and feature form guidance">
          {contactReasons.map(({ icon: Icon, title, text }) => (
            <article className="contact-reason" key={title}>
              <div className="contact-reason__icon">
                <Icon size={18} strokeWidth={1.7} />
              </div>
              <div>
                <h2>{title}</h2>
                <p>{text}</p>
              </div>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
}

export default ContactPage;
